import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import CBNAPPFeatures from "./CBNAPPFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import APPBenefit from "../APPBenefits/APPBenefit";

// Main component for CBN APP
export default function CBNAPP() {
  // Overview data sections
  const data1 = [
    "Hyper-local Supply Chain Orchestration: Ensures precise coordination and efficiency in agricultural logistics at the local level.",
    "Loan Services: Provides access to financial assistance for farmers and agribusinesses.",
    "Buy and Sell Services: Offers a marketplace for trading agricultural goods and services.",
    "Agro Retailer Service: Connects farmers with agro retailers for easy access to agricultural inputs and products.",
  ];

  const data2 = [
    "Advisory Service: Provides expert agricultural advice to improve productivity and decision-making.",
    "Training Service: Empowers farmers with knowledge and skills for sustainable agriculture.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["CBN APP"]}
        DownloadText="Download App"
        dlLink="https://play.google.com/store/apps/details?id=com.gbrapp.cbnapp"
        DlBtn="true"
      />

      {/*  Overview Section*/}
      <SolutionEcosystem title="Overview" type="CBN" />

      {/*  Overview Features */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/*  Features & Benefits section */}
      <CBNAPPFeatures />
      <APPBenefit />
    </>
  );
}
